import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
export function sub(_ref, _ref2) {
  var _ref3 = _slicedToArray(_ref, 2),
    x1 = _ref3[0],
    y1 = _ref3[1];
  var _ref4 = _slicedToArray(_ref2, 2),
    x2 = _ref4[0],
    y2 = _ref4[1];
  return [x1 - x2, y1 - y2];
}
export function add(_ref5, _ref6) {
  var _ref7 = _slicedToArray(_ref5, 2),
    x1 = _ref7[0],
    y1 = _ref7[1];
  var _ref8 = _slicedToArray(_ref6, 2),
    x2 = _ref8[0],
    y2 = _ref8[1];
  return [x1 + x2, y1 + y2];
}
export function dist(_ref9, _ref10) {
  var _ref11 = _slicedToArray(_ref9, 2),
    x0 = _ref11[0],
    y0 = _ref11[1];
  var _ref12 = _slicedToArray(_ref10, 2),
    x1 = _ref12[0],
    y1 = _ref12[1];
  return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
}
/**
 * Calculate angle of vector [x, y].
 */
export function angle(_ref13) {
  var _ref14 = _slicedToArray(_ref13, 2),
    x = _ref14[0],
    y = _ref14[1];
  return Math.atan2(y, x);
}
/**
 * Calculate angle of [x, y], then + Math.PI / 2.
 * Because of the difference between `Geometric coordinate system` and `Visualization coordinate system`.
 * @returns
 */
export function angleWithQuadrant(_ref15) {
  var _ref16 = _slicedToArray(_ref15, 2),
    x = _ref16[0],
    y = _ref16[1];
  return angle([x, y]) + Math.PI / 2;
}
export function angleBetween(v0, v1) {
  var a0 = angle(v0);
  var a1 = angle(v1);
  if (a0 < a1) return a1 - a0;
  return Math.PI * 2 - (a0 - a1);
}
export function calcBBox(points) {
  var minX = Infinity;
  var maxX = -Infinity;
  var minY = Infinity;
  var maxY = -Infinity;
  var _iterator = _createForOfIteratorHelper(points),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        x = _step$value[0],
        y = _step$value[1];
      minX = Math.min(x, minX);
      maxX = Math.max(x, maxX);
      minY = Math.min(y, minY);
      maxY = Math.max(y, maxY);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var width = maxX - minX;
  var height = maxY - minY;
  return [minX, minY, width, height];
}
/**
 * Get the center of two points.
 */
export function mid(_ref17, _ref18) {
  var _ref19 = _slicedToArray(_ref17, 2),
    x1 = _ref19[0],
    y1 = _ref19[1];
  var _ref20 = _slicedToArray(_ref18, 2),
    x2 = _ref20[0],
    y2 = _ref20[1];
  return [(x1 + x2) / 2, (y1 + y2) / 2];
}